import { action, observable } from 'mobx';

import RecommendedRepository from '~repositories/RecommendedRepository/RecommendedItemsRepository';
import CartRepository from '~repositories/CartRepository/CartRepository';

export interface IRecommendedViewControllerProps {
    recommendedRepo: RecommendedRepository;
    cartRepo: CartRepository;
}

export default class RecommendedItemsViewController {
    @observable private readonly _recommendedRepo: RecommendedRepository;
    @observable private _cartRepo: CartRepository;

    constructor({ recommendedRepo, cartRepo }: IRecommendedViewControllerProps) {
        this._recommendedRepo = recommendedRepo;
        this._cartRepo = cartRepo;
    }

    @action public getRecommendedProductIds = () => this._recommendedRepo.getRecommendedItems();

    @action public isProductInCart = (productId: string) =>
        this._cartRepo.cart.cartItems.find(({ skuId }) => skuId !== productId);
}
